import React, { Component } from 'react';
// import { green, red, yellow } from '@material-ui/core/colors';
import { useExpanded, useGroupBy, useTable } from 'react-table'

import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import ArrowDropUp from '@material-ui/icons/ArrowDropUp';
import BackdropProgress from './core/components/BackdropProgress';
import CheckCircle from '@material-ui/icons/CheckCircle';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MaUTable from '@material-ui/core/Table';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import Skeleton from '@material-ui/lab/Skeleton';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Title from './Title';
// import findVersions from 'find-versions';
import { releaseService } from '_services';
// import semverRegex from 'semver-regex';
import semverTruncate from 'semver-truncate';
// import env_info from '../data/envInfo.json';
import { withStyles } from '@material-ui/core/styles';

// import ExpandLess from '@material-ui/icons/ExpandLess';
// import ExpandMore from '@material-ui/icons/ExpandMore';

const useStyles = theme => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    margin: theme.spacing(2),
    marginTop: theme.spacing(0),
  },
  fixedHeight: {
    height: 240,
  },
});

const status = {
  paddingTop: 2
  // color: "green"
}

const statusColorMap = {
  Running: "green",
  Failed: "red",
  "Not Running": "red",
  undefined: "yellow"
};

const clusters = [
  "useks",
  "eueks",
  "jpeks",
  "usqaeks",
  "euqaeks",
  "usdeveks",
  "eudeveks"  
];

const columns = [
    {
      Header: 'Environment Status',
      columns: [
        {
          Header: 'Customer',
          accessor: 'customer',
          aggregate: 'count',
          Aggregated: ({ value }) => `${value} Customers`,
        },
        {
          Header: 'Environment',
          accessor: 'environment',
          aggregate: 'uniqueCount',
          Aggregated: ({ value }) => `${value} Env's`,
        },
        {
          Header: 'Country',
          accessor: 'country',
          aggregate: 'uniqueCount',
          Aggregated: ({ value }) => `${value} Countries`,
        },  
        {
          Header: 'Release',
          accessor: 'release',
          aggregate: 'uniqueCount',
          Aggregated: ({ value }) => `${value} Release`,
        },      
        {
          Header: 'App',
          accessor: 'artifact',
          aggregate: 'uniqueCount',
          Aggregated: ({ value }) => `${value} App's`,
        },
        {
          Header: 'Version',
          accessor: 'version',
        },
        {
          Header: 'Cluster',
          accessor: 'server',
        },
        {
          Header: 'Status',
          accessor: 'status',
          Cell: (props) => {
            return (
              <div style={status} > {props.value} <CheckCircle fontSize="small"  style={{ color: statusColorMap[props.value] || 'grey' }} /> </div>
            );
          }
        },
      ],
    },
  ];

  
  function Table({ columns, data }) {
    // Use the state and functions returned from useTable to build your UI
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow,
    } = useTable(
      {
        columns,
        data,
     },
      useGroupBy,
      useExpanded // useGroupBy would be pretty useless without useExpanded ;)
    )
  
    // Render the UI for your table
    return (
      <MaUTable {...getTableProps()}>
        <TableHead>
          {headerGroups.map(headerGroup => (
            <TableRow  {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <TableCell {...column.getHeaderProps()}>
                  {column.canGroupBy ? (
                      // If the column can be grouped, let's add a toggle
                      <span {...column.getGroupByToggleProps()}>
                        {column.isGrouped ? <ArrowDropUp color='secondary' fontSize="small"/> : <ArrowDropDown color='action' fontSize="small"/>}
                      </span>
                    ) : null}
                  {column.render('Header')}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableHead>
        <TableBody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row)
            return (
              <TableRow hover {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return (
                    <TableCell {...cell.getCellProps()}
                    style={{
                      background: cell.isGrouped
                        ? '#fafafa'
                        : cell.isAggregated
                        ? 'white'
                        : cell.isPlaceholder
                        ? 'white'
                        : 'white',
                    }}
                    >
                      {cell.isGrouped ? (
                          // If it's a grouped cell, add an expander and row count
                          <>
                            <span {...row.getToggleRowExpandedProps()}>
                              {row.isExpanded ? '👇' : '👉'}
                            </span>{' '}
                            {cell.render('Cell')} ({row.subRows.length})
                          </>
                        ) : cell.isAggregated ? (
                          // If the cell is aggregated, use the Aggregated
                          // renderer for cell
                          cell.render('Aggregated')
                        ) : cell.isPlaceholder ? null : ( // For cells with repeated values, render null
                          // Otherwise, just render the regular cell
                          cell.render('Cell')
                        )}
                    </TableCell>
                  )
                })}
              </TableRow>
            )
          })}
        </TableBody>
      </MaUTable>
    )
  }
class ProdEnvInfoC extends Component {
  constructor() {
    super()
    this.state = {
      loading: false,
      envInfo: [],
      envInfoExcluded: [],
      clusters: [],
      currentCluster: '',
    };
    this.handleEnvChange = this.handleEnvChange.bind(this);

  }

  getEnvInfo(env) {
    let localInfo = []
    let localInfoExcluded = []
    releaseService.getEnvInfo(env).then(
      
      (data) => {
        data.forEach(element => {
          if (element.version.includes('-') ){
            element.release = semverTruncate(element.version, 'patch')
            localInfo.push(element)
          } else {
            localInfoExcluded.push(element)
          }
        }); 
        this.setState({
          loading: false,
          envInfo: localInfo,
          envInfoExcluded: localInfoExcluded,
        });
      },
      (error) => {
        this.setState({
          loading: false,
          envInfo: [],
        });     
       },
    );
  }

  getClusters() {
    this.setState({
      clusters: clusters
    })
  }

  handleEnvChange = (e) => {
    let cCluster = e.target.value

    this.setState({
      currentCluster: cCluster
    })
    this.getEnvInfo(cCluster)
  }  
  
  componentDidMount() {
    this.setState({ loading: true })
    this.getClusters()
    this.getEnvInfo('useks')
  }
  
  
  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
          <Title>Environment Info</Title>
          {this.state.loading && <BackdropProgress loading={this.state.loading} />}

              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">EKS Cluster</InputLabel>
                <Select  value={this.state.currentCluster} onChange={(e) => this.handleEnvChange(e)}>
                <MenuItem value="">
                  <em>Select Cluster</em>
                </MenuItem>
                {this.state.clusters.map(function(name, index){
                    return <MenuItem key={index} value={name}>{name}</MenuItem>;
                  })}
                </Select>
              </FormControl>
              <br></br>
              {this.state.loading ? (
                <Skeleton variant="rect" width="100%"></Skeleton>
              ) : (
            <Table className={classes.table} aria-label="simple table" columns={columns} data={this.state.envInfo} />
              )}
          </Paper>
        </Grid>
      </React.Fragment>
    );
  
  }
}

export default withStyles(useStyles)(ProdEnvInfoC) 
